import { render, staticRenderFns } from "./BuyingStationProductionList.vue?vue&type=template&id=dead7124"
import script from "./BuyingStationProductionList.vue?vue&type=script&lang=js"
export * from "./BuyingStationProductionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports